import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { Auth, API, graphqlOperation } from "aws-amplify";
import CustomOverlay from "../../../components/CustomOverlay";
import PrivacyPolicySeller from "../../../components/privacyPolicySeller";
import FormSeller from "../../../components/forms/seller";
import CardSeller from "../../../components/cards/seller";
import { createSeller } from "../../../graphql/mutations";

const registerSeller = async (sellerData) => {
  try {
    // Auth.currentSession() で ID トークンを取得
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken(); // IDトークンを取得

    // GraphQL のミューテーション
    const mutation = `
      mutation CreateSeller($input: CreateSellerInput!) {
        createSeller(input: $input) {
          id
          name
          address
          phone
          postal
          invoiceRegistrationNumber
        }
      }
    `;

    // API リクエストの送信（認証情報を含める）
    const response = await API.graphql({
      query: mutation,
      variables: { input: sellerData },
      authMode: "AMAZON_COGNITO_USER_POOLS", // 認証モードを指定
      headers: {
        Authorization: token, // 認証トークンをヘッダーに追加
      },
    });

    alert("出品者情報を登録しました！");
  } catch (error) {
    console.error("登録エラー", error);

    if (error.errors) {
      console.error("GraphQL エラー:", error.errors);
      alert(`登録エラー: ${error.errors[0].message}`);
    } else {
      alert("登録エラーが発生しました。");
    }
  }
};

const SellerRegistration = () => {
  const [overlay, setOverlay] = useState(true);
  const [showRegistration, setShowRegistration] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConnectBtn, setShowConnectBtn] = useState(false);
  const [showCreateProductBtn, setShowCreateProductBtn] = useState(false);
  const [sellerForm, setSellerForm] = useState({
    name: "",
    address: "",
    phone: "",
    postalFirst: "",
    postalSecond: "",
    invoiceRegistrationNumber: "", 
  });
  const [checkPrivacyPolicy, setCheckPrivacyPolicy] = useState(false);
  const [currentUserInfo, setCurrentUserInfo] = useState({});

  useEffect(() => {
    const fetchSellerInfo = async () => {
      try {
        const userInfo = await Auth.currentAuthenticatedUser();
        setCurrentUserInfo(userInfo);

        const getSeller = `
          query GetSeller {
            getSeller(id: "${userInfo.attributes.sub}") {
              id
              name
              stripeID
              address
              phone
              postal
              invoiceRegistrationNumber
            }
          }
        `;

        const response = await API.graphql(graphqlOperation(getSeller));
        const seller = response.data.getSeller;

        if (seller.stripeID) {
          setShowCreateProductBtn(true);
        } else if (seller.name && seller.address && seller.phone && seller.postal) {
          setShowConnectBtn(true);
        } else {
          setShowRegistration(true);
        }
        setOverlay(false);
      } catch (error) {
      // alert("ログインが必要です。再度ログインしてください。");
        console.error(error);
        setShowRegistration(true);//
        setOverlay(false);
      }
    };

    fetchSellerInfo();
  }, []);

  const goToConfirm = () => {
    setShowRegistration(false);
    setShowConfirm(true);
  };

  const backToInput = () => {
    setShowConfirm(false);
    setShowRegistration(true);
  };

  const registrationSeller = async () => {
    const sellerData = {
      id: currentUserInfo.attributes.sub,
      email: currentUserInfo.attributes.email,
      name: sellerForm.name,
      address: sellerForm.address,
      phone: sellerForm.phone,
      postal: `${sellerForm.postalFirst}-${sellerForm.postalSecond}`,
      invoiceRegistrationNumber: sellerForm.invoiceRegistrationNumber,
    };

    try {
      setOverlay(true);
      await API.graphql({
        query: createSeller,
        variables: { input: sellerData },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      setShowRegistration(false);
      setShowConfirm(false);
      setShowConnectBtn(true);
      setOverlay(false);
    } catch (error) {
      console.error("GraphQL エラー:", JSON.stringify(error, null, 2));
      alert(
        "出品者情報の登録に失敗しました。入力内容をご確認いただき、時間を置いてから再度お試しください"
      );
      setOverlay(false);
    }
  };

  return (
      <Box mx="auto" maxWidth={600}>
        <CustomOverlay overlay={overlay} />

        <Grid container justifyContent="center" style={{ marginBottom: "16px" }}>
          <Typography variant="h5">出品者情報の登録</Typography>
        </Grid>

        {showRegistration && (
          <FormSeller
            sellerForm={sellerForm}
            setSellerForm={setSellerForm}
            validateBtn="内容確認"
            onValidate={goToConfirm}
          />
        )}   

        {showConfirm && (
          <>
            <Grid container justifyContent="center" style={{ margin: "16px 0" }}>
              <CardSeller sellerForm={sellerForm} />
            </Grid>
            <Grid container justifyContent="center" style={{ margin: "16px 0" }}>
              <PrivacyPolicySeller />
            </Grid>
            <Grid container justifyContent="center" style={{ margin: "16px 0" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkPrivacyPolicy}
                    onChange={(e) => setCheckPrivacyPolicy(e.target.checked)}
                  />
                }
                label="個人情報の取り扱いについて同意する"
              />
            </Grid>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item>
                <Button variant="contained" color="default" onClick={backToInput}>
                  戻る
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={registrationSeller}
                  disabled={!checkPrivacyPolicy}
                >
                  登録
                </Button>
              </Grid>
            </Grid>
          </>
        )}

        {showConnectBtn && (
          <>
            <Grid container justifyContent="center" style={{ margin: "16px 0" }}>
              <Typography variant="body1">出品者情報の登録を確認しました</Typography>
            </Grid>
            <Grid container justifyContent="center" style={{ margin: "16px 0" }}>
              <Typography variant="body1">
                商品を作成するためにはStripeと連携する必要があります
              </Typography>
            </Grid>
            <Grid container justifyContent="center" style={{ margin: "16px 0" }}>
              <Typography variant="body1">
                下記ボタンよりStripeとピッタプットを連携してください
              </Typography>
            </Grid>
            <Grid container justifyContent="center" style={{ marginBottom: "16px" }}>
              <Typography variant="body1">
                初めてStripeを利用される方は<Link to="/stripe_manual">こちら</Link>
              </Typography>
            </Grid>
            <Grid container justifyContent="center">
              <a
                href="https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_HMjw0lVlIUzcj0RMFSgE5sfRkizhNDsC&scope=read_write"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/image/stripe_manual/ConnectStripe.png"
                  alt="Stripeと連携"
                />
              </a>
            </Grid>
          </>
        )}

        {showCreateProductBtn && (
          <Box my={6}>
            <Grid container justifyContent="center" style={{ marginBottom: "16px" }}>
              <Typography variant="body1">出品者情報の確認ができました。</Typography>
              <Typography variant="body1">Stripeとの連携が確認できました。</Typography>
              <Typography variant="body1">
                下記ボタンより商品を作成できます。
              </Typography>
            </Grid>
            <Grid container justifyContent="center">
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/products/new"
              >
                商品を作成する
              </Button>
            </Grid>
          </Box>
        )}
      </Box>
  );
};

export default SellerRegistration;